import { jsx, jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import { Box, Dialog, DialogContent, Stack, dialogContentClasses } from "@mui/material";
import { Close } from "mdi-material-ui";
import { IconButton } from "../IconButton/index.js";
import { Typography } from "../Typography/index.js";
import { translateSizeToMaterialSize } from "../../utils/translate-size.js";
const ModalBase_ModalBase = /*#__PURE__*/ forwardRef(function({ open, children, title, TitleIcon, Footer, onClose, size = 'medium', badge }, ref) {
    const hasHeader = !!title || !!onClose || !!badge;
    const hasFooter = !!Footer;
    return /*#__PURE__*/ jsxs(Dialog, {
        ref: ref,
        open: open,
        onClose: onClose,
        scroll: "paper",
        keepMounted: false,
        fullWidth: true,
        maxWidth: translateSizeToMaterialSize(size),
        "aria-labelledby": "modal-title",
        fullScreen: 'fullScreen' === size,
        children: [
            hasHeader && /*#__PURE__*/ jsxs(Box, {
                padding: (theme)=>theme.spacing(1, 2),
                children: [
                    /*#__PURE__*/ jsxs(Stack, {
                        direction: "row",
                        spacing: 1,
                        alignItems: "center",
                        children: [
                            TitleIcon && /*#__PURE__*/ jsx(TitleIcon, {
                                fontSize: "small"
                            }),
                            /*#__PURE__*/ jsx(Typography, {
                                variant: "h3",
                                minHeight: "24px",
                                id: "modal-title",
                                children: title
                            }),
                            badge && /*#__PURE__*/ jsx("div", {
                                children: badge
                            })
                        ]
                    }),
                    onClose && /*#__PURE__*/ jsx(IconButton, {
                        "aria-label": "Close",
                        onClick: onClose,
                        sx: (theme)=>({
                                position: 'absolute',
                                top: theme.spacing(0.5),
                                right: theme.spacing(0.5)
                            }),
                        children: /*#__PURE__*/ jsx(Close, {})
                    })
                ]
            }),
            children && /*#__PURE__*/ jsx(DialogContent, {
                sx: {
                    padding: 0,
                    [`&.${dialogContentClasses.dividers}`]: {
                        borderBottom: hasFooter ? void 0 : 'none'
                    }
                },
                children: children
            }),
            Footer
        ]
    });
});
export { ModalBase_ModalBase as ModalBase };

//# sourceMappingURL=ModalBase.js.map